module.exports = __webpack_public_path__ + "img/knue_gallery3.46d19c8e.jpg";